import Vue from "vue"
import store from "@/store/"
import Toaster from "./components/toaster"
import events from "@/bl-events"

const initToaster = () => {
  const el = document.querySelector("#vue-toaster")

  if (!el) {
    return
  }

  const config = JSON.parse(el.dataset.config)

  setTimeout(() => {
    for (const id in config.items) {
      store.dispatch("toaster/push", {
        id,
        message: config.items[id],
        type: id
      })
    }
  }, 100)

  // Global events to trigger toast
  // Useful when working from legacy JS
  events.on("toast", ({ type, message }) => {
    store.dispatch("toaster/push", {
      id: type,
      message,
      type
    })
  })

  new Vue({
    name: "ToasterInit",
    el,
    store,
    render: (h) => h(Toaster)
  })
}

export default initToaster
